import {
  Action,
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Dispatch,
} from "redux";
import thunk, { ThunkAction, ThunkDispatch } from "redux-thunk";
import config from "./config";
import notification, {
  NotificationState,
} from "./notification/notification-reducer";
import auth, { AuthState } from "./auth/auth-reducer";
import race, { IRaceStore } from "./race/race-reducer";
import { Store } from "react-redux";
import client, { ClientState } from "./client";
import initialState from "../initialState";
import driver, { IDriverStore } from "./driver";
import admin, { IAdminStore } from "./admin";
import fcm, { IFCMStore } from "./fcm";
import { IConfigStore } from "./config";
import company, { CompanyState } from "./company";
import order, { OrderState } from "./order";
import category, { ICategoryStore } from "./category";
import product, { IProductStore } from "./product";
import branch, { IBranchStore } from "./branch";

declare var window: { __REDUX_DEVTOOLS_EXTENSION__: any };

let middleware = [thunk];
const enhancers = [];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }

  const reduxImmutableStateInvariant =
    require("redux-immutable-state-invariant").default();
  const { logger } = require(`redux-logger`);
  middleware = [...middleware, reduxImmutableStateInvariant, logger];
} else {
  middleware = [...middleware];
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export interface IStore {
  readonly auth: AuthState;
  readonly notification: NotificationState;
  readonly client: ClientState;
  readonly driver: IDriverStore;
  readonly race: IRaceStore;
  readonly admin: IAdminStore;
  readonly fcm: IFCMStore;
  readonly company: CompanyState;
  readonly config: IConfigStore;
  readonly order: OrderState;
  readonly category: ICategoryStore;
  readonly product: IProductStore;
  readonly branch: IBranchStore;
}

const rootReducer = combineReducers({
  notification,
  auth,
  race,
  client,
  driver,
  admin,
  fcm,
  company,
  order,
  category,
  product,
  branch,
  config,
});

export type AppThunk = ThunkAction<void, IStore, null, Action<any>>;
export type AppDispatch = ThunkDispatch<IStore, null, Action<any>>;

export default function configureStore(): Store<IStore> & {
  dispatch: Dispatch;
} {
  return createStore(rootReducer, initialState, composedEnhancers);
}



// WEBPACK FOOTER //
// ./src/store/index.ts